module.exports = __webpack_public_path__ + "img/Bigmail.96e8e3af.png";